import { useEffect, useState } from "react";
import aboutimage from "../image/man-9252300_960_720.jpg";
// import swastik from "../image/swastik.png"; // ✅ ADD THIS
import { URL } from "../Redux/common/url";
import { FaArrowRight } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

export default function AboutGold() {
  const [productLists, setProductLists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(`${URL.API_BASE_URL}/publicApi/aboutnewListPublic`);
      const data = await response.json();
      setProductLists(data?.aboutnew || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p className="text-center py-5">Loading...</p>;

  return (
    <section className="py-5 bg-white">
      {productLists.map((item, index) => (
        <div className="container-fluid" key={index}>
          <div className="row align-items-center">

            <div className="col-md-6  position-relative">
              <img  src={URL?.API_BASE_URL + item?.feature_image}
                    alt={item.title} className="shadow w-100 product-img-out"  />

              <div className="position-absolute text-white text-center fw-bold shadow"
                style={{ top: "50%", left: "-20px", transform: "translateY(-50%)", background: "#ff5e00", padding: "18px 22px", borderRadius: "8px" }}>
                <div style={{ fontSize: "26px" }}>5000+</div>
                <div style={{ fontSize: "10px" }}>YEARS OF HERITAGE</div>
              </div>
            </div>

            <div className="col-md-6">
              <h6 className="fw-bold text-warning" style={{fontSize: "26px"}}>{item.title}</h6>
              <h2 className="fw-bold text-warning" style={{fontSize: "26px"}}>{item.subheading}</h2>
              <p>{item.short_description}</p>

              <ul className="list-unstyled">
                {[item.subheading_one, item.subheading_two, item.subheading_three].map((text, i) => (
                  <li key={i} className="mb-2">
                    <FaArrowRight className="text-danger me-2" />
                    {/* <img src={swastik} style={{ width: "20px" }} /> */}
                    <span className="ms-2">{text}</span>
                  </li>
                ))}
              </ul>

              <button className="btn text-white mt-3" style={{ background: "#ff5e00" }}>
                Explore More →
              </button>
            </div>

          </div>
        </div>
      ))}
    </section>
  );
}